<template>
    <v-container>
        <v-card>
            <v-card-title class="justify-center primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-file-pdf</v-icon>
                <v-toolbar-title id="titulocard"> Unificar documentos a PDF</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text v-if="showDocumentos">
                <v-row class="mt-1">
                    <v-col cols="6" md="6" sm="6">
                    </v-col>
                    <v-col cols="6" md="6" sm="6" style="display: flex; justify-content: end;">
                        <v-btn color="#536DFE" style="color:white" :disabled="disSiguiente" @click="Siguiente()">
                            Siguiente
                            <v-icon right>
                                mdi-arrow-right-bold-circle-outline
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <DataTable class="tablaPDF" :url="urlListado" :columns="columns" :order="[[0, 'asc']]"
                            @apiDT="apiDT = $event" select="multiple" :params="displayInputs" :reduce="fila => fila.docid"
                            @input="seleccionarDocumentos" :dom="'Bfrtip'" @SeleccionTabla="SeleccionTablaTipo">
                        </DataTable>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <div>
                            Aclaraciones:
                            <ul class='lista'>
                                <li>
                                    Es importante que revise que toda la documentación esté completa, de caso contrario solo
                                    se
                                    podrá adjuntar aquellos documentos subidos correctamente.
                                </li>
                                <li>
                                    Si alguna de las imágenes o PDF's subidos presenta inconsistencias (se encuentran
                                    dañados y/u
                                    ofuscados) no serán agregados.
                                </li>
                                <li>
                                    Si presenta algún problema comunicarse a desarrollo@ausa.com.mx (adjunte el archivo PDF
                                    generado, si aplica, y el reporte e índice con el nombre de los documentos que
                                    selecciono)
                                    previamente habiendo revisado que todos los documentos cumplan con lo anterior.
                                </li>
                            </ul>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text v-else>
                <v-row class="mt-1">
                    <v-col cols="6" md="6" sm="6">
                        <v-btn color="#FF5C93" style="color:white" :disabled="disSiguiente" @click="Regresar()">
                            <v-icon left>
                                mdi-arrow-left-bold-circle-outline
                            </v-icon>
                            Regresar
                        </v-btn>
                    </v-col>
                </v-row>
                <div class="mt-2">
                    <p style="font-weight: bold;">
                        Para reordenar las filas, sitúese en la columna titulada 'ORDEN'. Luego, arrastre la fila hasta la
                        posición deseada para establecer el orden de aparición en el documento PDF, ya sea en secuencia
                        ascendente o descendente.
                    </p>

                </div>
                <v-row>
                    <v-col>
                        <DataTable :url="urlDocumentos" :columns="columnsDocumentos" :order="[[0, 'asc']]"
                            @apiDT="apiDT = $event" :params="displayDocs" :rowReorder="{ enabled: true, dataSrc: 'seq' }"
                            :movil="true" :perPage="50">
                        </DataTable>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" style="display: flex; justify-content: center;">
                        <v-btn @click="GenerarPDF()" color="#00BCD4" style="color:white">
                            <v-icon left>
                                mdi-file-pdf
                            </v-icon>
                            Generar PDF
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import DataTable from "@/components/pages/DataTableNet/DataTable";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Archivos from '@/services/Archivos/Archivos.service.js';
import moment from 'moment'

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        DataTable,

    },
    data: function () {
        return {
            disSiguiente: true,
            urlListado: 'Archivos/ListadoArchivosReporte',
            columns: [
                { name: 'Iniciales', data: 'doiniciales', title: 'Iniciales' },
                { name: 'Descripción', data: 'dodescrip', title: 'Descripción' },
                { name: 'Núm de Archivos escaneados', data: 'docpaginas', title: 'Núm de Archivos escaneados' },
                { name: 'Fecha escaneo', data: 'docalta', title: 'Fecha escaneo' },
                { name: 'Usuario', data: 'uslogin', title: 'Usuario' },
            ],
            apiDT: null,
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0
            },
            documentos: [],
            showDocumentos: true,

            displayDocs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0,
                documentos: ''
            },
            urlDocumentos: 'Archivos/DocumentosSeleccionados',
            columnsDocumentos: [
                { name: 'Orden', data: 'seq', title: 'Orden' },
                { name: 'Iniciales', data: 'doiniciales', title: 'Iniciales', orderable: false },
                { name: 'Descripción', data: 'dodescrip', title: 'Descripción', orderable: false },
                { name: 'Núm de Archivos escaneados', data: 'docpaginas', title: 'Núm de Archivos escaneados', orderable: false },
                { name: 'Fecha escaneo', data: 'docalta', title: 'Fecha escaneo', orderable: false },
                { name: 'Usuario', data: 'uslogin', title: 'Usuario', orderable: false },
            ],
        }
    },
    watch: {
        'documentos'(val) {
            this.disSiguiente = val.length > 0 ? false : true
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
    },
    async mounted() {
        this.changeReporteMenuOption('NoView');
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice,
            aiclave: this.datos.aiclave,
        };
        this.reloadTable();
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        seleccionarDocumentos(reporte) {
            this.documentos = reporte;
        },
        Siguiente() {
            this.showDocumentos = false;
            this.displayDocs = {
                nrreporte: this.datos.nrreporte,
                svindice: this.datos.svindice,
                aiclave: this.datos.aiclave,
                documentos: this.documentos.join()
            };
            this.reloadTable();
        },
        Regresar() {
            this.showDocumentos = true;
            this.disSiguiente = true;
        },
        async GenerarPDF() {
            this.$swal({
                title: 'Creando archivo, espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    const doctos = this.apiDT.rows().data().toArray()
                    this.documentos = doctos.map(function (objeto) {
                        return objeto.docid;
                    });
                    let today = moment().format('yyyy-MM-DD');
                    let response = await Archivos.GenerarPDF(this.datos, this.documentos.join())
                    if (response != null) {
                        const url = window.URL.createObjectURL(new Blob([response]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.datos.nrreporte + '-' + this.datos.svindice + '-documentos_' + today.toString() + '.pdf');
                        document.body.appendChild(link);
                        link.click()
                        var formData = new FormData();
                        formData.append("lasitio", 'Prusia+');
                        formData.append("lomodulo", "Documentos");
                        formData.append("laaccion", "Descarga");
                        formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                        formData.append("lanombre", this.datos.nrreporte + '-' + this.datos.svindice + '.zip');
                        formData.append("ladestinatario", "");
                        await Archivos.AlmacenarVisitas(formData);
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Correcto',
                            text: 'Archivo creado correctamente',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 2500
                        }).then(async () => {
                            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
                            this.$router.push({ path: asistenciaurl + '/Archivos' });


                        });
                    } else {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Error',
                            text: 'Ocurrio un error, intentelo más tarde!!',
                            showConfirmButton: false,
                            timer: 2500
                        });
                    }

                }
            });
        },
        SeleccionTablaTipo(tipo) {
            if (tipo == 1) {
                this.apiDT.rows().select();
            } else if (tipo == 2) {
                this.apiDT.rows().deselect();
            } else if (tipo == 3) {
                this.apiDT.rows().every(function () {
                    if (this.nodes().to$().hasClass('selected')) {
                        this.deselect();
                    } else {
                        this.select();
                    }
                });
            }
        },
    },

}
</script>

<style>
.tablaPDF div.dt-buttons {
    float: right;
}

.tablaPDF div.dataTables_wrapper div.dataTables_filter {
    text-align: left;
}

.tablaPDF .dataTables_wrapper .dataTables_filter {
    float: left;
    text-align: left;
}
</style>